let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fgDVq")).then(() => parcelRequire('B1a5R'));